import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {AmbienteEnum} from '../../shared/enums/ambiente-enum';
import {SociedadEnum} from '../../shared/enums/sociedad-enum';
import {MENU_PERMISSIONS} from '../constants/menu-permissions.constant';

export const PRODUCTOS_MENU: AppMenuItem = {
  "children": [
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Exclusivos",
      "route": "productos/exclusivos",
      "proceso": MENU_PERMISSIONS.exclusivos,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Esencias",
      "route": "productos/esencias",
      "proceso": MENU_PERMISSIONS.esencias,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Semiterminados",
      "route": "productos/asistente",
      "proceso": MENU_PERMISSIONS.semiterminados,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Terminados",
      "route": "productos/producto-terminado",
      "proceso": MENU_PERMISSIONS.productoTerminado,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Categorías",
      "route": "productos/categorias",
      "proceso": MENU_PERMISSIONS.categorias,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Familia Olfativa",
      "route": "productos/familia-olfativa",
      "proceso": MENU_PERMISSIONS.familiaOlfativa,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Kits",
      "route": "productos/kits",
      "proceso": MENU_PERMISSIONS.kits,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Perfumol",
      "route": "productos/perfumol",
      "proceso": MENU_PERMISSIONS.perfumol,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Accesorios",
      "route": "productos/accesorios",
      "proceso": MENU_PERMISSIONS.accesorios,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Capacidades",
      "route": "productos/capacidades",
      "proceso": MENU_PERMISSIONS.capacidades,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "label": "Mantenimiento Producto",
      "route": "productos/mantenimiento-producto",
      "proceso": MENU_PERMISSIONS.mantenimientoProducto,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    }
  ],
  "label": "Productos",
  "visible": true
};
